import get from "lodash/get";
import { theme } from "@styles/theme";

export const getThemeValue = (path: string): string | number | number[] => {
  const _v = get(theme, path, {});

  return _v ? _v : path;
};
